// Client-side filtering/grouping for the T-CAIREM resources page. The full
// curated set is loaded up front, so no server round-trips are needed here.

const names = (tags) => (tags || []).map(tag => tag.name ?? tag)

export const groupByTypeTag = (resources, typeTags, personaTagNames = null) =>
    (typeTags || [])
        .filter(tag => typeTagMatchesPersonas(tag, personaTagNames))
        .map(tag => tag.name ?? tag)
        .map(tagName => ({
            tagName,
            resources: resources.filter(r => names(r.tcairem_type_tags).includes(tagName)),
        }))
        .filter(group => group.resources.length > 0)

export const matchesPersona = (resource, personaTagNames) => {
    if (!personaTagNames || personaTagNames.length === 0) return true
    const personas = names(resource.tcairem_persona_tags)
    return personaTagNames.some(tagName => personas.includes(tagName))
}

// A T-CAIREM Resource Type tag's `personas` field restricts which persona(s)
// it applies to (issue #724): it fits when it shares at least one persona
// with personaNames. A tag with no personas is unrestricted, and null /
// undefined personaNames means no persona context, so everything fits; an
// empty array fits only unrestricted tags.
export const typeTagMatchesPersonas = (typeTag, personaNames) => {
    const tagPersonas = names(typeTag?.personas)
    if (tagPersonas.length === 0 || personaNames == null) return true
    return personaNames.some(p => tagPersonas.includes(p))
}

export const matchesSearch = (resource, { title = '', contentTags = [], audienceTags = [] }) => {
    if (title && !resource.title.toLowerCase().includes(title.toLowerCase())) return false
    if (contentTags.length > 0 && !contentTags.some(t => names(resource.content_tags).includes(t))) return false
    if (audienceTags.length > 0) {
        const audience = [...names(resource.demographic_tags), ...names(resource.experience_tags)]
        if (!audienceTags.some(t => audience.includes(t))) return false
    }
    return true
}
